import { useRentalManagerUserPropertyUnarchiveWebApiHandler_unarchive } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { DEFAULT_ARCHIVE_INVALIDATES } from '../../constants/InvalidateConstants';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type UnarchivePropertyOptions = Parameters<typeof useRentalManagerUserPropertyUnarchiveWebApiHandler_unarchive>[0];

type UnarchivePropertyMutateOptions = MutateOptions<
  void,
  unknown,
  RentalManagerUserPropertyUnarchiveWebApiHandler_unarchive_Args
>;

/**
 * Unarchives a property and its dupes via /api/web/v1/users/properties/unarchive.
 *
 * Merges default `meta.invalidates` (plus any `meta.invalidates` you pass) and sets `meta.context`
 * for logging unless overridden.
 */
export const useUnarchiveProperty = (options: UnarchivePropertyOptions = {}) => {
  const { meta: metaOverrides, ...restOptions } = options;

  const mutation = useRentalManagerUserPropertyUnarchiveWebApiHandler_unarchive({
    ...restOptions,
    meta: {
      ...metaOverrides,
      invalidates: [...DEFAULT_ARCHIVE_INVALIDATES, ...(metaOverrides?.invalidates ?? [])],
      context: {
        api: 'unarchive',
        details: 'useUnarchiveProperty',
        ...metaOverrides?.context,
      },
    },
  });

  const unarchiveProperty = (listingAlias: ListingAlias, mutateOptions?: UnarchivePropertyMutateOptions) =>
    mutation.mutate({ postData: { listingAlias } }, mutateOptions);

  return { ...mutation, unarchiveProperty };
};
